import React from 'react';
import {Alert, Card, Tabs} from "antd";
import {getNormalizedColumnName} from "../../utils/normalizers";
import Call from "../../hocs/call";
import {getArtefactTripletFromString} from "../../utils/sdmxJson";
import {connect} from "react-redux";
import {DataLanguageConsumer} from "../../contexts/DataLanguage";
import {compose} from "redux";
import {translate} from 'react-i18next';
import _ from "lodash";
import {getTreeFilterStrFromObj} from "./utils";
import {addSpinnerAction, completeSpinnerAction} from "../../middlewares/spinner/actions";
import {showQueryFormSpinner} from "./actions";
import CustomEmpty from "../custom-empty";
import TreeFilterTimePeriod from "./TimePeriod";
import TreeFilterTree from "./Tree";

const mapStateToProps = state => ({
  endpointId: state.app.endpointId,
  nodes: state.config.nodes,
  appLanguage: state.app.language,
  maxTreeNodes: state.config.userInterface.maxTreeNodes,
  dataLanguages: state.config.dataManagement.dataLanguages
});

const mapDispatchToProps = dispatch => ({
  showSpinner: uuid => dispatch(addSpinnerAction(showQueryFormSpinner(), uuid)),
  hideSpinner: uuid => dispatch(completeSpinnerAction(showQueryFormSpinner(), uuid))
});

class TreeFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currentTab: "0",
      tempTPFrom: null,
      tempTPTo: null
    }
  };

  render() {

    const {
      t,
      nodes,
      appLanguage,
      dataLanguages,
      endpointId,
      maxTreeNodes,
      fetchColumnCodelistCount,
      fetchColumnCodelistTree,
      fetchColumnFilteredValues,
      columns,
      treeFilter,
      onColumnModeChange,
      onColumnValuesChange,
      showSpinner,
      hideSpinner,
      disabled,
      hideInclusionRadio,
      isCC,
      isSdmx,
      minDate,
      maxDate,
      hideIds,
      showTimePeriodAsTree
    } = this.props;
    const itemsOrderAnnotationType =
      _.find(nodes, node => node.general.id === endpointId).annotations.codelistsOrder;

    const callOnColumnValuesChangeWithSpinner = (colName, values) => {
      showSpinner();
      window.setTimeout(() => {
        hideSpinner();
        onColumnValuesChange(colName, values);
      }, 0);
    };

    const callOnColumnModeChangeWithSpinner = (colName, mode) => {
      showSpinner();
      window.setTimeout(() => {
        hideSpinner();
        onColumnModeChange(colName, mode);
      }, 0);
    };

    const freqCol = columns.find(({name}) => name === "FREQ" || name === "ID_FREQ");

    return (
      <DataLanguageConsumer>
        {dataLanguage =>
          (columns !== null && (isCC || columns.filter(({CodelistCode}) => CodelistCode).length > 0))
            ? (
              <Tabs onChange={key => this.setState({currentTab: key})}>
                {(columns || [])
                  .filter(({CodelistCode}) => CodelistCode !== undefined)
                  .filter(({name}) => !isCC || getNormalizedColumnName(name) !== "TID")
                  .map((column, index) =>
                    <Tabs.TabPane
                      tab={<span title={column.name}>{getNormalizedColumnName(column.name)}</span>}
                      key={index}
                    >
                      <Call
                        cb={fetchColumnCodelistCount}
                        cbParam={{
                          codelistTriplet: column.CodelistCode !== null ? getArtefactTripletFromString(column.CodelistCode) : null,
                          language: dataLanguage || appLanguage,
                          dimensionId: column.id
                        }}
                        disabled={column.CodelistCode === null || column.codelistCount !== null}
                      >
                        {column.codelistCount !== null && column.codelistCount > maxTreeNodes
                          ? (
                            <Alert
                              type="warning"
                              showIcon
                              message={t('components.treeFilter.warnings.codelistTooBig.title')}
                            />
                          )
                          : column.hasCodesError
                            ? (
                              <Alert
                                type="error"
                                showIcon
                                message={t('components.treeFilter.errors.codesError.title')}
                              />
                            )
                            : (
                              <Call
                                cb={fetchColumnCodelistTree}
                                cbParam={{
                                  codelistTriplet: column.CodelistCode === null || getArtefactTripletFromString(column.CodelistCode),
                                  language: dataLanguage || appLanguage,
                                  itemsOrderAnnotationType,
                                  dimensionId: column.id
                                }}
                                disabled={column.CodelistCode === null || column.codelistCount === null || column.codelistTree !== null}
                              >
                                <Call
                                  cb={fetchColumnFilteredValues}
                                  cbParam={{
                                    colNames: columns.map(({name}) => name).splice(0, index + 1),
                                    filterStr: getTreeFilterStrFromObj(treeFilter, columns.slice(0, index).map(({name}) => name))
                                  }}
                                  disabled={
                                    fetchColumnFilteredValues === null ||
                                    (column.CodelistCode !== null && (column.codelistTree === null || column.filteredCodelistTree !== null)) ||
                                    (!isCC && column.CodelistCode === null && column.filteredValues === null) ||
                                    this.state.currentTab !== String(index)
                                  }
                                >
                                  {
                                    (showTimePeriodAsTree || (column.name !== "ID_TIME_PERIOD" && column.name !== "TIME_PERIOD"))
                                      ? (
                                        <TreeFilterTree
                                          column={column}
                                          dataLanguage={dataLanguage}
                                          appLanguage={appLanguage}
                                          dataLanguages={dataLanguages}
                                          treeFilter={treeFilter}
                                          isCC={isCC}
                                          columns={columns}
                                          callOnColumnValuesChangeWithSpinner={callOnColumnValuesChangeWithSpinner}
                                          index={index}
                                          disabled={disabled}
                                          hideInclusionRadio={hideInclusionRadio}
                                          setTPFromTo={obj => this.setState(obj)}
                                          callOnColumnModeChangeWithSpinner={callOnColumnModeChangeWithSpinner}
                                          hideIds={hideIds}
                                        />
                                      )
                                      : (
                                        <Call
                                          cb={fetchColumnCodelistCount}
                                          cbParam={{
                                            codelistTriplet: freqCol
                                              ? (freqCol.CodelistCode === null || getArtefactTripletFromString(freqCol.CodelistCode))
                                              : null,
                                            language: dataLanguage || appLanguage,
                                            dimensionId: column.id
                                          }}
                                          disabled={!freqCol || freqCol.CodelistCode === null || freqCol.codelistCount !== null}
                                        >
                                          <Call
                                            cb={fetchColumnCodelistTree}
                                            cbParam={{
                                              codelistTriplet: freqCol
                                                ? (freqCol.CodelistCode === null || getArtefactTripletFromString(freqCol.CodelistCode))
                                                : null,
                                              language: dataLanguage || appLanguage,
                                              itemsOrderAnnotationType,
                                              dimensionId: column.id
                                            }}
                                            disabled={
                                              !freqCol || !isCC || !fetchColumnFilteredValues ||
                                              freqCol.CodelistCode === null || freqCol.codelistCount === null ||
                                              freqCol.codelistTree !== null}
                                          >
                                            <Call
                                              cb={fetchColumnFilteredValues}
                                              cbParam={{
                                                colNames: [freqCol ? freqCol.name : null],
                                                filterStr: ""
                                              }}
                                              disabled={
                                                !freqCol || !isCC || !fetchColumnFilteredValues ||
                                                (freqCol.CodelistCode !== null && (freqCol.codelistTree === null || freqCol.filteredCodelistTree !== null)) ||
                                                (!isCC && freqCol.CodelistCode === null && freqCol.filteredValues === null) ||
                                                this.state.currentTab !== String(index)
                                              }
                                            >
                                              <TreeFilterTimePeriod
                                                disabled={disabled}
                                                treeFilter={treeFilter}
                                                columns={columns}
                                                column={column}
                                                index={index}
                                                isCC={isCC}
                                                isSdmx={isSdmx}
                                                tempTPFrom={this.state.tempTPFrom}
                                                tempTPTo={this.state.tempTPTo}
                                                setTPFromTo={obj => this.setState(obj)}
                                                callOnColumnValuesChangeWithSpinner={callOnColumnValuesChangeWithSpinner}
                                                usePickers={!fetchColumnFilteredValues}
                                                minDate={minDate}
                                                maxDate={maxDate}
                                              />
                                            </Call>
                                          </Call>
                                        </Call>
                                      )}
                                </Call>
                              </Call>
                            )}
                      </Call>
                    </Tabs.TabPane>
                  )}
              </Tabs>
            )
            : (
              <Card bodyStyle={{height: 526}}>
                <CustomEmpty/>
              </Card>
            )}
      </DataLanguageConsumer>
    );
  }
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(TreeFilter);



// WEBPACK FOOTER //
// ./src/components/tree-filter/index.jsx